import { createSvgIcon } from '@mui/material';
import ArrowCircleDown from '../public/moderne-icons/ArrowCircleDown.svg';
import ArrowCircleUp from '../public/moderne-icons/ArrowCircleUpIcon.svg';
import AzureDevOpsIcon from '../public/moderne-icons/AzureDevOpsIcon.svg';
import BitbucketIcon from '../public/moderne-icons/BitbucketIcon.svg';
import CancelIcon from '../public/moderne-icons/CancelIcon.svg';
import CheckboxCheckedIcon from '../public/moderne-icons/CheckboxCheckedIcon.svg';
import CheckboxIndeterminateIcon from '../public/moderne-icons/CheckboxIndeterminateIcon.svg';
import CheckboxUncheckedIcon from '../public/moderne-icons/CheckboxUncheckedIcon.svg';
import CheckedOutlineIcon from '../public/moderne-icons/CheckedOutlineIcon.svg';
import ColumnsIcon from '../public/moderne-icons/ColumnsIcon.svg';
import DoubleArrowReset from '../public/moderne-icons/DoubleArrowReset.svg';
import ErrorIcon from '../public/moderne-icons/ErrorIcon.svg';
import ExportIcon from '../public/moderne-icons/ExportIcon.svg';
import ExternalLinkIcon from '../public/moderne-icons/ExternalLinkIcon.svg';
import FileAddedIcon from '../public/moderne-icons/FileAddedIcon.svg';
import FileModifiedIcon from '../public/moderne-icons/FileModifiedIcon.svg';
import FileRemovedIcon from '../public/moderne-icons/FileRemovedIcon.svg';
import FileRenamedIcon from '../public/moderne-icons/FileRenamedIcon.svg';
import FilterListIcon from '../public/moderne-icons/FilterListIcon.svg';
import GitHubIcon from '../public/moderne-icons/GitHubIcon.svg';
import GitLabIcon from '../public/moderne-icons/GitLabIcon.svg';
import GraphQLIcon from '../public/moderne-icons/GraphQLIcon.svg';
import KebabMenuIcon from '../public/moderne-icons/KabobMenuIcon.svg';
import LeftClickRotateIcon from '../public/moderne-icons/LeftClickRotateIcon.svg';
import RecommendedSortIcon from '../public/moderne-icons/RecommendedSortIcon.svg';
import ReloadIcon from '../public/moderne-icons/ReloadIcon.svg';
import RightClickPanIcon from '../public/moderne-icons/RightClickPanIcon.svg';
import ScrollWheelIcon from '../public/moderne-icons/ScrollWheelIcon.svg';
import ShareIcon from '../public/moderne-icons/ShareIcon.svg';
import SortAZAlphaIcon from '../public/moderne-icons/SortAZAlphaIcon.svg';
import SortZAAlphaIcon from '../public/moderne-icons/SortZAAlphaIcon.svg';
import TurtleSlowLaneIcon from '../public/moderne-icons/TurtleSlowLaneIcon.svg';
import WarningIcon from '../public/moderne-icons/WarningIcon.svg';

export const ModArrowCircleDown = createSvgIcon(
  ArrowCircleDown(),
  'ModArrowCircleDown'
);
export const ModArrowCircleUp = createSvgIcon(
  ArrowCircleUp(),
  'ModArrowCircleUp'
);
export const ModAzureDevOpsIcon = createSvgIcon(
  AzureDevOpsIcon(),
  'ModAzureDevOpsIcon'
);
export const ModBitbucketIcon = createSvgIcon(
  BitbucketIcon(),
  'ModBitbucketIcon'
);
export const ModCancelIcon = createSvgIcon(CancelIcon(), 'ModCancelIcon');

export const ModCheckboxCheckedIcon = createSvgIcon(
  CheckboxCheckedIcon(),
  'ModCheckboxCheckedIcon'
);

export const ModCheckboxIndeterminateIcon = createSvgIcon(
  CheckboxIndeterminateIcon(),
  'ModCheckboxIndeterminateIcon'
);

export const ModCheckboxUncheckedIcon = createSvgIcon(
  CheckboxUncheckedIcon(),
  'ModCheckboxUncheckedIcon'
);

export const ModCheckedOutlineIcon = createSvgIcon(
  CheckedOutlineIcon(),
  'ModCheckedOutlineIcon'
);

export const ModColumnsIcon = createSvgIcon(ColumnsIcon(), 'ModColumnsIcon');

export const ModDoubleArrowIcon = createSvgIcon(
  DoubleArrowReset(),
  'ModDoubleArrowIcon'
);

export const ModErrorIcon = createSvgIcon(ErrorIcon(), 'ModErrorIcon');
export const ModKebabMenuIcon = createSvgIcon(
  KebabMenuIcon(),
  'ModKebabMenuIcon'
);
export const ModExportIcon = createSvgIcon(ExportIcon(), 'ModExportIcon');
export const ModExternalLinkIcon = createSvgIcon(
  ExternalLinkIcon(),
  'ModExternalLinkIcon'
);

export const ModFileAddedIcon = createSvgIcon(
  FileAddedIcon(),
  'ModFileAddedIcon'
);
export const ModFileModifiedIcon = createSvgIcon(
  FileModifiedIcon(),
  'ModFileModifiedIcon'
);
export const ModFileRemovedIcon = createSvgIcon(
  FileRemovedIcon(),
  'ModFileRemovedIcon'
);
export const ModFileRenamedIcon = createSvgIcon(
  FileRenamedIcon(),
  'ModFileRenamedIcon'
);

export const ModFilterListIcon = createSvgIcon(
  FilterListIcon(),
  'ModFilterListIcon'
);

export const ModGitHubIcon = createSvgIcon(GitHubIcon(), 'ModGitHubIcon');
export const ModGitLabIcon = createSvgIcon(GitLabIcon(), 'ModGitLabIcon');

export const ModGraphQLIcon = createSvgIcon(GraphQLIcon(), 'ModGraphQLIcon');
export const ModRecommendedSortIcon = createSvgIcon(
  RecommendedSortIcon(),
  'ModRecommendedSortIcon'
);
export const ModReloadIcon = createSvgIcon(ReloadIcon(), 'ModReloadIcon');

export const ModShareIcon = createSvgIcon(ShareIcon(), 'ModShareIcon');
export const ModSortAZAlphaIcon = createSvgIcon(
  SortAZAlphaIcon(),
  'ModSortAZAlphaIcon'
);
export const ModSortZAAlphaIcon = createSvgIcon(
  SortZAAlphaIcon(),
  'ModSortZAAlphaIcon'
);

// TODO: swap for the design system's `turtle_slow_lane` icon once it ships in a
// released @moderneinc/design-system-components version (see #8477).
export const ModTurtleSlowLaneIcon = createSvgIcon(
  TurtleSlowLaneIcon(),
  'ModTurtleSlowLaneIcon'
);

export const ModWarningIcon = createSvgIcon(WarningIcon(), 'ModWarningIcon');

export const ModScrollWheelIcon = createSvgIcon(
  ScrollWheelIcon(),
  'ModScrollWheelIcon'
);
export const ModRightClickPanIcon = createSvgIcon(
  RightClickPanIcon(),
  'ModScrollWheelIcon'
);
export const ModLeftClickRotateIcon = createSvgIcon(
  LeftClickRotateIcon(),
  'ModScrollWheelIcon'
);
